//----------------------------------------------
//update the marker cache with the new markers
//new_order is an array with the key/index as new number, and the value the uuid
//----------------------------------------------
import { ReinosMaps } from '../../core'

ReinosMaps.prototype.updateMarkerCache = function (mapID, new_order) {
  const self = this

  if (Array.isArray(new_order)) {
    const new_cache = []

    new_order.forEach((v, k) => {
      const marker = self.searchMarker(mapID, v)

      if (marker !== undefined) {
        const old_markerNumber = marker.markerNumber

        //set the new marker
        marker.markerNumber = k
        self.markers[mapID][old_markerNumber].keys[0] = k

        //save to new cache
        new_cache.push(self.markers[mapID][old_markerNumber])
      }
    })

    //set the new cache
    self.markers[mapID] = new_cache
  }
}
